var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EFF3F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12656_38318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 12L19 16H22C22 19.31 19.31 22 16 22C14.99 22 14.03 21.75 13.2 21.3L11.74 22.76C12.97 23.54 14.43 24 16 24C20.42 24 24 20.42 24 16H27L23 12ZM10 16C10 12.69 12.69 10 16 10C17.01 10 17.97 10.25 18.8 10.7L20.26 9.24C19.03 8.46 17.57 8 16 8C11.58 8 8 11.58 8 16H5L9 20L13 16H10Z",
    fill: "#255986"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12656_38318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset-icon.05666c122f0a9306c6af4f69856a63a9.svg";
export { ForwardRef as ReactComponent };